import { render, staticRenderFns } from "./HCO3.vue?vue&type=template&id=bbbce110&scoped=true&"
import script from "./HCO3.vue?vue&type=script&lang=js&"
export * from "./HCO3.vue?vue&type=script&lang=js&"
import style0 from "./HCO3.vue?vue&type=style&index=0&id=bbbce110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbce110",
  null
  
)

export default component.exports